export const API_URL_LOCAL = 'http://localhost:8080/v1/graphql'
export const API_URL_DEV =
  'https://prod.base-sepolia.intuition-api.com/v1/graphql'
export const API_URL_PROD =
  'https://prod.base-mainnet-v-1-0.intuition.sh/v1/graphql'
